import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Avatar,
  IconButton,
  Grid,
  Typography,
  Divider,
} from "@material-ui/core";

import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
}));

export default function ItemListing(props) {
  const classes = useStyles();
  const {
    pageTitle,
    data,
    avatarIcon,
    onEditAction,
    onDeleteAction,
    canShowEdit = true,
    canShowDelete = true,
    canShowPageTitle = true,
  } = props;
  return (
    <div className={classes.root}>
      <Grid item xs={12} md={12}>
        {canShowPageTitle && (
          <Typography variant="h6" className={classes.title}>
            {pageTitle}
          </Typography>
        )}
        <div className={classes.demo}>
          <List>
            {data.map((val, idx) => (
              <div key={idx}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>{avatarIcon}</Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={val.name} />
                  <ListItemSecondaryAction>
                    {canShowEdit && (
                      <IconButton
                        onClick={() => onEditAction()}
                        edge="end"
                        aria-label="delete"
                      >
                        <CreateIcon />
                      </IconButton>
                    )}
                    {canShowDelete && (
                      <IconButton
                        onClick={() => onDeleteAction()}
                        edge="end"
                        aria-label="delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
                {idx !== data.length - 1 ? <Divider /> : null}
              </div>
            ))}
          </List>
        </div>
      </Grid>
    </div>
  );
}
